import React from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import "./index.css";
import { App } from "./App";
import { AdminView } from "./views/AdminView";
import { AnalyticsView } from "./views/AnalyticsView";
import { HistoryView } from "./views/HistoryView";
import { LiveView } from "./views/LiveView";
import { WallboardView } from "./views/WallboardView";

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <App />,
      children: [
        { index: true, element: <LiveView /> },
        { path: "history", element: <HistoryView /> },
        { path: "analytics", element: <AnalyticsView /> },
        // The wallboard renders inside the shell too; it hides the nav itself
        // when fullscreened onto a TV.
        { path: "wallboard", element: <WallboardView /> },
        // Admin config that used to live only on the PoC console.
        { path: "admin", element: <AdminView /> },
      ],
    },
  ],
  { basename: "/supervisor" },
);

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
